<div class="modal-top-bar">
    <h2>{{editMode ? 'Edit' : 'Create'}} device</h2>
</div>
<div class="modal-content edit-backup-device-container">
    <div>
        <form class="general" [formGroup]="form">
            <div>
                <div class="device-row">
                    <span class="form-field-header">Device name</span>
                    <input formControlName="name" type="text" placeholder="..." required/>
                    <span *ngIf="form.controls['name'].errors != null" class="error-message">Required</span>
                </div>
                <div class="device-row">
                    <span class="form-field-header">Address</span>
                    <input formControlName="address" type="text" placeholder="x.x.x.x" required/>
                    <span *ngIf="form.controls['address'].errors != null" class="error-message">Invalid IP address</span>
                </div>
            </div>
            <div>
                <div class="device-row">
                    <span class="form-field-header">User</span>
                    <input formControlName="user" type="text" placeholder="" required/>
                    <span *ngIf="form.controls['user'].errors != null" class="error-message">Required</span>
                </div>
                <div class="device-row">
                    <span class="form-field-header">Password</span>
                    <input formControlName="password" type="password" placeholder="" required/>
                    <span *ngIf="form.controls['password'].errors != null" class="error-message">Required</span>
                </div>
            </div>
            <div class="device-row">
                <span class="form-field-header">File system</span>
                <select formControlName="type" required>
                    <option *ngIf="form.value.type == null" [value]="null">Select File system</option>
                    <option [value]="deviceCIFS">CIFS</option>
                    <option [value]="deviceNFS">NFS</option>
                </select>
                <span *ngIf="form.controls['type'].errors != null" class="error-message">Required</span>
            </div>
            <div class="device-row">
                <span class="form-field-header">Root folder</span>
                <input formControlName="rootFolder" type="text" placeholder="/"/>
                <span>Root folder is "/" if not specified</span>
            </div>
        </form>
    </div>
</div>
<div class="modal-bottom-bar">
    <button class="button outline mini wide" (click)="cancel()">Close</button>
    <button class="button mini wide" [disabled]="!form.valid || working" (click)="save()">{{working? 'Saving...': 'Save'}}</button>
</div>